import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "using-aio-cli"
    }}>{`Using aio CLI`}</h1>
    <pre><code parentName="pre" {...{}}>{`USAGE
  $ aio runtime

OPTIONS
  -i, --insecure  bypass certificate check
  -u, --auth      whisk auth
  -v, --verbose   Verbose output
  --apihost       whisk API host
  --apiversion    whisk API version
  --cert          client cert
  --debug=debug   Debug level output
  --help          Show help
  --key           client key
  --version       Show version

ALIASES
  $ aio rt

COMMANDS
  runtime:action      Manage your actions
  runtime:activation  Manage your activations
  runtime:deploy      The Runtime Deployment Tool
  runtime:namespace   Manage your namespaces
  runtime:package     Manage your packages
  runtime:property    Execute property commands
  runtime:route       Manage your routes
  runtime:rule        Manage your rules
  runtime:trigger     Manage your triggers
`}</code></pre>
    <p>{`Each command also offers help, so you can for example, run `}<inlineCode parentName="p">{`aio runtime action --help`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      